export default __webpack_public_path__ + "static/media/Clear.6ba725f9.png";